// Code used from https://github.com/awesomejerry/react-native-qrcode-svg
// react-native-qrcode-svg is licensed under The MIT License (MIT)
import QRCode from 'qrcode';
export default (function (value, errorCorrectionLevel) {
    var arr = Array.prototype.slice.call(QRCode.create(value, { errorCorrectionLevel: errorCorrectionLevel }).modules.data, 0);
    var sqrt = Math.sqrt(arr.length);
    return arr.reduce(function (rows, key, index) { return (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows; }, []);
});
